import Loading from '@/views/common/Loading'
import Login from '@/views/common/Login'
import Cart from '@/views/customer/Cart'
import Center from '@/views/customer/Center'
import Details from '@/views/customer/Details'
import Home from '@/views/customer/Home'
import OrderConfirm from '@/views/customer/OrderConfirm'
import Orderform from '@/views/customer/Orderform'
import NotFound from '@/views/exception/NotFound'
import Console from '@/views/management/Console'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Loading',
      component: Loading,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/details',
      name: 'Details',
      component: Details,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/orderconfirm',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/orderform',
      name: 'Orderform',
      component: Orderform,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/center',
      name: 'Center',
      component: Center,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/console',
      name: 'Console',
      component: Console,
      meta: {
        requireAuth: true,
      },
      children: [
        {
          path: 'mysetting',
          component: () => import('@/views/management/menu/MySetting'),
        },
        {
          path: 'international_customer',
          component: () => import('@/views/management/user/Customer'),
        },
        {
          path: 'domestic_customer',
          component: () => import('@/views/management/user/Customer2'),
        },
        {
          path: 'international_order',
          component: () => import('@/views/management/order/OrderLists'),
        },
        // {
        //   path: 'domestic_order',
        //   component: () =>
        //     import("@/views/management/order/OrderLists2")
        // },
        {
          path: 'quickordering',
          component: () => import('@/views/management/order/QuickOrdering'),
        },
        {
          path: 'globalemail',
          component: () => import('@/views/management/order/GlobalEmail'),
        },
        {
          path: 'w-order',
          component: () => import('@/views/management/ecommerce/Worder'),
        },
        {
          path: 'shopify',
          component: () => import('@/views/management/ecommerce/Shopify'),
        },
        {
          path: 'synproducts',
          component: () => import('@/views/management/product/SynProducts'),
        },
        {
          path: 'pricingrules',
          component: () => import('@/views/management/product/PricingRules'),
        },
        {
          path: 'discountrules',
          component: () => import('@/views/management/product/DiscountRules'),
        },
        {
          path: 'pricesystem',
          component: () => import('@/views/management/product/PriceSystem'),
        },
        {
          path: 'pricesystemdetail',
          name: 'pricesystemdetail',
          component: () => import('@/views/management/product/PriceSystemDetail'),
        },
        {
          path: 'country',
          component: () => import('@/views/management/property/Country'),
        },
        {
          path: 'currency',
          component: () => import('@/views/management/property/Currency'),
        },
        // {
        //   path: 'exchangerate',
        //   component: () =>
        //     import("@/views/management/property/ExchangeRate")
        // },
        // {
        //   path: 'unit',
        //   component: () =>
        //     import("@/views/management/property/Unit")
        // },
        {
          path: 'payment',
          component: () => import('@/views/management/property/Payment'),
        },
        {
          path: 'orderstatus',
          component: () => import('@/views/management/property/OrderStatus'),
        },
        {
          path: 'brand',
          component: () => import('@/views/management/property/Brand'),
        },
        {
          path: 'satisfacationsurvey',
          component: () =>
            import('@/views/management/feedback/SatisfacationSurvey'),
        },
        {
          path: 'standardorder',
          component: () => import('@/views/management/3pl/StandardOrder'),
        },
        {
          path: 'webstoreorder',
          component: () => import('@/views/management/3pl/WebStoreOrder'),
        },
        {
          path: 'serialnumbertool',
          component: () =>
            import('@/views/management/aftersales/SerialNumberTool'),
        },
        // {
        //   path: 'analysis',
        //   component: () =>
        //     import("@/views/management/datac/Analysis")
        // }
        {
          path: 'shopifyorder',
          component: () => import('@/views/dataplatform/OrderShopify'),
          meta: { requiresAuth: false }
        },
        {
          path: 'shopifydetail',
          name: "shopifydetail",
          component: () => import('@/views/dataplatform/OrderDetail'),
          meta: { requiresAuth: false }
        },
      ],
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js